import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "dashboard-area pt-120 mb-120" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row g-lg-4 gy-5 mb-90" }
const _hoisted_4 = { class: "col-lg-9" }
const _hoisted_5 = { class: "dashboard-inner" }
const _hoisted_6 = { class: "form-wrapper mb-60" }
const _hoisted_7 = { class: "section-title" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h5", null, "My Portfolio", -1)
const _hoisted_9 = {
  key: 0,
  id: "myForm",
  class: "edit-profile-form profile-form mb-4",
  enctype: "multipart/form-data"
}
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-12" }
const _hoisted_12 = { class: "form-inner mb-25" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, "Title*", -1)
const _hoisted_14 = { class: "input-area" }
const _hoisted_15 = { class: "col-md-12" }
const _hoisted_16 = { class: "form-inner mb-25" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", null, "Description*", -1)
const _hoisted_18 = { class: "col-md-12" }
const _hoisted_19 = { class: "form-inner mb-25" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", null, "Work or page url*", -1)
const _hoisted_21 = { class: "input-area" }
const _hoisted_22 = { class: "col-sm-6" }
const _hoisted_23 = { class: "form-inner mb-25" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", null, "Start Date*", -1)
const _hoisted_25 = { class: "input-area" }
const _hoisted_26 = { class: "col-sm-6" }
const _hoisted_27 = { class: "form-inner mb-25" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", null, "End Date*", -1)
const _hoisted_29 = { class: "input-area" }
const _hoisted_30 = { class: "col-md-12" }
const _hoisted_31 = { class: "form-inner mb-25" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", null, "Skill Used*", -1)
const _hoisted_33 = { class: "col-md-12" }
const _hoisted_34 = { class: "form-inner mb-25" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", null, "Video Link Url*", -1)
const _hoisted_36 = { class: "input-area" }
const _hoisted_37 = { class: "col-md-6" }
const _hoisted_38 = { class: "form-inner mb-25" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", null, "Other File*", -1)
const _hoisted_40 = { class: "input-area" }
const _hoisted_41 = { class: "col-md-6" }
const _hoisted_42 = { class: "form-inner mb-25" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", null, "Images*", -1)
const _hoisted_44 = { class: "input-area" }
const _hoisted_45 = { class: "col-md-12" }
const _hoisted_46 = { class: "file-previews" }
const _hoisted_47 = { class: "row" }
const _hoisted_48 = {
  class: "file-previews",
  style: {"position":"relative","width":"680px!"}
}
const _hoisted_49 = ["onClick"]
const _hoisted_50 = ["src"]
const _hoisted_51 = ["src"]
const _hoisted_52 = { class: "col-md-12" }
const _hoisted_53 = { class: "form-inner" }
const _hoisted_54 = {
  key: 1,
  class: "primry-btn-2 lg-btn w-unset",
  type: "button"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", { class: "me-3 fs-6 text-white" }, "Processing...", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-spinner fa-spin text-white ms-3",
  style: {"font-size":"24px"}
}, null, -1)
const _hoisted_57 = [
  _hoisted_55,
  _hoisted_56
]
const _hoisted_58 = {
  key: 1,
  class: "edit-profile-form profile-form mb-4"
}
const _hoisted_59 = { class: "row" }
const _hoisted_60 = { class: "col-md-12" }
const _hoisted_61 = { class: "card" }
const _hoisted_62 = { class: "card-header d-flex justify-content-between" }
const _hoisted_63 = { class: "card-title" }
const _hoisted_64 = { class: "card-body" }
const _hoisted_65 = { class: "d-flex justify-content-between" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("h5", { class: "title" }, "Title: ", -1)
const _hoisted_67 = { class: "title" }
const _hoisted_68 = { class: "d-flex justify-content-between" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("h5", { class: "title" }, "Description: ", -1)
const _hoisted_70 = { class: "title" }
const _hoisted_71 = { class: "d-flex justify-content-between" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("h5", { class: "title" }, "Url: ", -1)
const _hoisted_73 = { class: "title" }
const _hoisted_74 = { class: "d-flex justify-content-between" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("h5", { class: "title" }, "Start Date: ", -1)
const _hoisted_76 = { class: "title" }
const _hoisted_77 = { class: "d-flex justify-content-between" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("h5", { class: "title" }, "End Date: ", -1)
const _hoisted_79 = { class: "title" }
const _hoisted_80 = { class: "d-flex justify-content-between" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("h5", { class: "title" }, "Skill Used: ", -1)
const _hoisted_82 = { class: "title" }
const _hoisted_83 = { class: "d-flex justify-content-between" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("h5", { class: "title" }, "Video Links: ", -1)
const _hoisted_85 = ["href"]
const _hoisted_86 = { class: "row" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("h5", { class: "title" }, "Images", -1)
const _hoisted_88 = { class: "col-md-4 mb-3" }
const _hoisted_89 = { class: "card h-100" }
const _hoisted_90 = { class: "card-body d-flex justify-content-center align-itme-center" }
const _hoisted_91 = ["src"]
const _hoisted_92 = { class: "d-flex justify-content-around" }
const _hoisted_93 = {
  key: 1,
  class: "primry-btn-2 lg-btn w-unset",
  type: "button"
}
const _hoisted_94 = /*#__PURE__*/_createElementVNode("span", { class: "me-3 fs-6 text-white" }, "Processing...", -1)
const _hoisted_95 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-spinner fa-spin text-white ms-3",
  style: {"font-size":"24px"}
}, null, -1)
const _hoisted_96 = [
  _hoisted_94,
  _hoisted_95
]
const _hoisted_97 = {
  key: 0,
  class: "table-wrapper"
}
const _hoisted_98 = /*#__PURE__*/_createElementVNode("h5", { class: "title" }, "All Portfolio Item List:", -1)
const _hoisted_99 = { class: "scroll-table" }
const _hoisted_100 = { class: "eg-table table category-table mb-0" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Portfolio Title"),
    /*#__PURE__*/_createElementVNode("th", null, "Description"),
    /*#__PURE__*/_createElementVNode("th", null, "Skills"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1)
const _hoisted_102 = { key: 0 }
const _hoisted_103 = { key: 0 }
const _hoisted_104 = { "data-label": "Job Title" }
const _hoisted_105 = { class: "company-info" }
const _hoisted_106 = { class: "logo" }
const _hoisted_107 = ["src"]
const _hoisted_108 = {
  key: 1,
  src: "/assets/images/bg/company-logo/company-06.png",
  alt: ""
}
const _hoisted_109 = { class: "company-details" }
const _hoisted_110 = { "data-label": "Apply Job" }
const _hoisted_111 = { "data-label": "Company" }
const _hoisted_112 = { "data-label": "Status" }
const _hoisted_113 = { class: "d-flex justify-content-between" }
const _hoisted_114 = ["onClick"]
const _hoisted_115 = /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "10",
  viewBox: "0 0 14 10",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M14 5C14 5 11.375 0 7 0C2.625 0 0 5 0 5C0 5 2.625 10 7 10C11.375 10 14 5 14 5ZM1.02637 5C1.44945 4.33193 1.93606 3.70971 2.47887 3.14273C3.605 1.97091 5.145 0.909091 7 0.909091C8.855 0.909091 10.3941 1.97091 11.522 3.14273C12.0648 3.70971 12.5514 4.33193 12.9745 5C12.9237 5.07909 12.8678 5.16636 12.8039 5.26182C12.5108 5.69818 12.0776 6.28 11.522 6.85727C10.3941 8.02909 8.85413 9.09091 7 9.09091C5.145 9.09091 3.60588 8.02909 2.478 6.85727C1.93519 6.29028 1.44946 5.66807 1.02637 5Z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M7 2.72721C6.41984 2.72721 5.86344 2.96665 5.4532 3.39287C5.04297 3.81909 4.8125 4.39717 4.8125 4.99993C4.8125 5.6027 5.04297 6.18078 5.4532 6.60699C5.86344 7.03321 6.41984 7.27266 7 7.27266C7.58016 7.27266 8.13656 7.03321 8.5468 6.60699C8.95703 6.18078 9.1875 5.6027 9.1875 4.99993C9.1875 4.39717 8.95703 3.81909 8.5468 3.39287C8.13656 2.96665 7.58016 2.72721 7 2.72721ZM3.9375 4.99993C3.9375 4.15606 4.26016 3.34676 4.83449 2.75005C5.40882 2.15334 6.18777 1.81812 7 1.81812C7.81223 1.81812 8.59118 2.15334 9.16551 2.75005C9.73984 3.34676 10.0625 4.15606 10.0625 4.99993C10.0625 5.8438 9.73984 6.65311 9.16551 7.24982C8.59118 7.84652 7.81223 8.18175 7 8.18175C6.18777 8.18175 5.40882 7.84652 4.83449 7.24982C4.26016 6.65311 3.9375 5.8438 3.9375 4.99993Z" })
], -1)
const _hoisted_116 = [
  _hoisted_115
]
const _hoisted_117 = ["onClick"]
const _hoisted_118 = /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M11.8798 1.19201C11.9563 1.26957 11.9993 1.37462 11.9993 1.48414C11.9993 1.59365 11.9563 1.6987 11.8798 1.77627L11.0253 2.64024L9.3868 0.98512L10.2413 0.121149C10.3181 0.0435774 10.4223 0 10.5309 0C10.6395 0 10.7437 0.0435774 10.8205 0.121149L11.8798 1.19118V1.19201ZM10.4461 3.22449L8.8076 1.56938L3.22607 7.20836C3.18098 7.2539 3.14704 7.30944 3.12694 7.37056L2.46745 9.36829C2.45549 9.40471 2.45379 9.44377 2.46254 9.48111C2.4713 9.51844 2.49016 9.55259 2.51702 9.57972C2.54388 9.60685 2.57768 9.62591 2.61464 9.63475C2.65161 9.64359 2.69028 9.64188 2.72633 9.62979L4.70399 8.96361C4.76442 8.94355 4.8194 8.90955 4.86456 8.8643L10.4461 3.22532V3.22449Z" }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M0 10.7585C0 11.0878 0.12947 11.4035 0.359928 11.6363C0.590385 11.8691 0.902953 11.9999 1.22887 11.9999H10.2406C10.5665 11.9999 10.8791 11.8691 11.1095 11.6363C11.34 11.4035 11.4694 11.0878 11.4694 10.7585V5.79319C11.4694 5.68345 11.4263 5.5782 11.3495 5.50061C11.2727 5.42301 11.1685 5.37941 11.0598 5.37941C10.9512 5.37941 10.847 5.42301 10.7702 5.50061C10.6934 5.5782 10.6502 5.68345 10.6502 5.79319V10.7585C10.6502 10.8683 10.607 10.9735 10.5302 11.0511C10.4534 11.1287 10.3492 11.1723 10.2406 11.1723H1.22887C1.12023 11.1723 1.01604 11.1287 0.939222 11.0511C0.862403 10.9735 0.819246 10.8683 0.819246 10.7585V1.6554C0.819246 1.54566 0.862403 1.44041 0.939222 1.36281C1.01604 1.28522 1.12023 1.24162 1.22887 1.24162H6.55397C6.66261 1.24162 6.7668 1.19803 6.84362 1.12043C6.92044 1.04283 6.96359 0.937583 6.96359 0.827842C6.96359 0.718101 6.92044 0.612854 6.84362 0.535256C6.7668 0.457657 6.66261 0.414063 6.55397 0.414062H1.22887C0.902953 0.414063 0.590385 0.544846 0.359928 0.777642C0.12947 1.01044 0 1.32618 0 1.6554V10.7585Z"
  })
], -1)
const _hoisted_119 = [
  _hoisted_118
]
const _hoisted_120 = ["onClick"]
const _hoisted_121 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-trash-fill",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" })
], -1)
const _hoisted_122 = [
  _hoisted_121
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_user_menu = _resolveComponent("user-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_user_menu),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                (!_ctx.showForm)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "primry-btn-2 lg-btn float-end",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addNewItem && _ctx.addNewItem(...args)))
                    }, " Add Portfolio "))
                  : _createCommentVNode("", true),
                (_ctx.showForm)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "primry-btn-2 lg-btn float-end",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancelForm && _ctx.cancelForm(...args)))
                    }, " Cancel "))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.showForm && !_ctx.showPortfolio)
                ? (_openBlock(), _createElementBlock("form", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _hoisted_13,
                          _createElementVNode("div", _hoisted_14, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.portfolio.title) = $event)),
                              name: "tile"
                            }, null, 512), [
                              [_vModelText, _ctx.portfolio.title]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _hoisted_17,
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.portfolio.description) = $event)),
                            id: "description",
                            required: ""
                          }, null, 512), [
                            [_vModelText, _ctx.portfolio.description]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _hoisted_20,
                          _createElementVNode("div", _hoisted_21, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.portfolio.url) = $event)),
                              name: "url"
                            }, null, 512), [
                              [_vModelText, _ctx.portfolio.url]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _hoisted_24,
                          _createElementVNode("div", _hoisted_25, [
                            _withDirectives(_createElementVNode("input", {
                              type: "date",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.portfolio.start_date) = $event)),
                              name: "startDate"
                            }, null, 512), [
                              [_vModelText, _ctx.portfolio.start_date]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _hoisted_28,
                          _createElementVNode("div", _hoisted_29, [
                            _withDirectives(_createElementVNode("input", {
                              type: "date",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.portfolio.end_date) = $event)),
                              name: "endDate"
                            }, null, 512), [
                              [_vModelText, _ctx.portfolio.end_date]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _hoisted_32,
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.portfolio.skill_used) = $event)),
                            id: "skill-used"
                          }, null, 512), [
                            [_vModelText, _ctx.portfolio.skill_used]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _hoisted_35,
                          _createElementVNode("div", _hoisted_36, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.portfolio.video_links) = $event)),
                              name: "portfolioID"
                            }, null, 512), [
                              [_vModelText, _ctx.portfolio.video_links]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _hoisted_39,
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("input", {
                              type: "file",
                              onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.otherFileHandle && _ctx.otherFileHandle(...args))),
                              name: "otherFile"
                            }, null, 32)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _hoisted_43,
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("input", {
                              type: "file",
                              onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args))),
                              name: "images[]",
                              multiple: ""
                            }, null, 32)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("div", _hoisted_47, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.portfolio.viewImages, (image, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "col-md-6 mb-3",
                                key: index
                              }, [
                                _createElementVNode("div", _hoisted_48, [
                                  _createElementVNode("span", {
                                    class: "float-end point",
                                    onClick: ($event: any) => (_ctx.removeImage(index))
                                  }, "x", 8, _hoisted_49),
                                  (image.image)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: image.image,
                                        alt: "Preview",
                                        style: {"width":"100%"}
                                      }, null, 8, _hoisted_50))
                                    : (_openBlock(), _createElementBlock("img", {
                                        key: 1,
                                        src: image.preview,
                                        alt: "Preview",
                                        style: {"width":"100%"}
                                      }, null, 8, _hoisted_51))
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("div", _hoisted_53, [
                          (!_ctx.isLoading)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.updatePortfolio && _ctx.updatePortfolio(...args))),
                                class: "primry-btn-2 lg-btn w-unset",
                                type: "button"
                              }, _toDisplayString(_ctx.portfolio.id == null ? 'Save Portfolio' : 'Update Portfolio'), 1))
                            : (_openBlock(), _createElementBlock("button", _hoisted_54, _hoisted_57))
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showPortfolio && !_ctx.showForm)
                ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, [
                          _createElementVNode("div", _hoisted_62, [
                            _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.viewPortfolio.title), 1),
                            _createElementVNode("div", null, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn-close",
                                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showPortfolio = false)),
                                "aria-label": "Close"
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_64, [
                            _createElementVNode("div", _hoisted_65, [
                              _hoisted_66,
                              _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.viewPortfolio.title), 1)
                            ]),
                            _createElementVNode("div", _hoisted_68, [
                              _hoisted_69,
                              _createElementVNode("span", _hoisted_70, _toDisplayString(_ctx.viewPortfolio.description), 1)
                            ]),
                            _createElementVNode("div", _hoisted_71, [
                              _hoisted_72,
                              _createElementVNode("span", _hoisted_73, _toDisplayString(_ctx.viewPortfolio.url), 1)
                            ]),
                            _createElementVNode("div", _hoisted_74, [
                              _hoisted_75,
                              _createElementVNode("span", _hoisted_76, _toDisplayString(_ctx.viewPortfolio.start_date), 1)
                            ]),
                            _createElementVNode("div", _hoisted_77, [
                              _hoisted_78,
                              _createElementVNode("span", _hoisted_79, _toDisplayString(_ctx.viewPortfolio.end_date), 1)
                            ]),
                            _createElementVNode("div", _hoisted_80, [
                              _hoisted_81,
                              _createElementVNode("span", _hoisted_82, _toDisplayString(_ctx.viewPortfolio.skill_used), 1)
                            ]),
                            _createElementVNode("div", _hoisted_83, [
                              _hoisted_84,
                              _createElementVNode("a", {
                                href: _ctx.viewPortfolio.video_links,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                class: "text-primary"
                              }, _toDisplayString(_ctx.viewPortfolio.video_links), 9, _hoisted_85)
                            ]),
                            _createElementVNode("div", _hoisted_86, [
                              _hoisted_87,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.viewPortfolio.images, (item) => {
                                return (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                  _createElementVNode("div", _hoisted_89, [
                                    _createElementVNode("div", _hoisted_90, [
                                      _createElementVNode("img", {
                                        src: item.image,
                                        alt: "",
                                        style: {"min-width":"120px !important","max-width":"170px !important"}
                                      }, null, 8, _hoisted_91)
                                    ])
                                  ])
                                ]))
                              }), 256))
                            ]),
                            _createElementVNode("div", _hoisted_92, [
                              (!_ctx.isLoading)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "primry-btn-2 lg-btn",
                                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.deletePortfolio(_ctx.viewPortfolio)))
                                  }, "Delete"))
                                : (_openBlock(), _createElementBlock("button", _hoisted_93, _hoisted_96))
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            (!_ctx.showForm && !_ctx.showPortfolio)
              ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                  _hoisted_98,
                  _createElementVNode("div", _hoisted_99, [
                    _createElementVNode("table", _hoisted_100, [
                      _hoisted_101,
                      _createElementVNode("tbody", null, [
                        (_ctx.userPortfolio.data && !_ctx.showForm)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_102, [
                              (_ctx.userPortfolio.data.length == 0)
                                ? (_openBlock(), _createElementBlock("h5", _hoisted_103, "No Portfolio..."))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userPortfolio.data, (portfolio) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: portfolio.id
                          }, [
                            _createElementVNode("td", _hoisted_104, [
                              _createElementVNode("div", _hoisted_105, [
                                _createElementVNode("div", _hoisted_106, [
                                  (portfolio.portfolio_images[0]?.image)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: portfolio.portfolio_images[0]?.image,
                                        alt: ""
                                      }, null, 8, _hoisted_107))
                                    : (_openBlock(), _createElementBlock("img", _hoisted_108))
                                ]),
                                _createElementVNode("div", _hoisted_109, [
                                  _createElementVNode("span", null, _toDisplayString(portfolio.title), 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_110, _toDisplayString(portfolio.description), 1),
                            _createElementVNode("td", _hoisted_111, [
                              _createElementVNode("span", null, _toDisplayString(portfolio.skill_used), 1)
                            ]),
                            _createElementVNode("td", _hoisted_112, [
                              _createElementVNode("div", _hoisted_113, [
                                _createElementVNode("span", {
                                  class: "btn",
                                  onClick: ($event: any) => (_ctx.viewPort(portfolio))
                                }, _hoisted_116, 8, _hoisted_114),
                                _createElementVNode("span", {
                                  class: "btn",
                                  onClick: ($event: any) => (_ctx.editView(portfolio))
                                }, _hoisted_119, 8, _hoisted_117),
                                _createElementVNode("span", {
                                  class: "btn",
                                  onClick: ($event: any) => (_ctx.deletePortfolio(portfolio))
                                }, _hoisted_122, 8, _hoisted_120)
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}